import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { GraphhopperRequest } from '../models/dtos/graph-hopper/graphhopper-request';
import { GraphhopperCustomer } from '../models/dtos/graph-hopper/graphhopper-customer';
import { GraphhopperResponse } from '../models/dtos/graph-hopper/graphhopper-response';


@Injectable({
    providedIn: 'root'
})
export class GraphhopperService {


    constructor(
        private networkService  : LeanNetworkService) {
    }

    //------------------------------------------------------------------------------------
    // Clusterise
    //------------------------------------------------------------------------------------
    clusterise(partners : Partner[], clustersNumber : number, minWeight : number, maxWeight : number) : Promise<GraphhopperResponse>{
        let request: GraphhopperRequest = new GraphhopperRequest();

        if ( (!partners) || (partners.length == 0)) return null;

        request.configuration.clustering.max_quantity = maxWeight;
        request.configuration.clustering.min_quantity = minWeight;
        request.configuration.clustering.num_clusters = clustersNumber;
        
        let graphhopperCustomer : GraphhopperCustomer;
        for (let partner of partners){
            graphhopperCustomer = new GraphhopperCustomer();
            graphhopperCustomer.address.lat = partner.latitude;
            graphhopperCustomer.address.lon = partner.longitude;
            graphhopperCustomer.id          = partner.partnerCode;
            graphhopperCustomer.quantity    = partner.weight;
            request.customers.push(graphhopperCustomer);
        }

        return new Promise((resolve, reject) => {
             let url  = 'https://graphhopper.com/api/1/cluster?key=11f88a55-b108-4151-b060-95e763882157';
            this.networkService.postToExternalServer(url, request).then(result => {
                    return resolve(result);
            });
        });
    }


}
